import React from 'react'
import { Switch, withRouter } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import Content from '../containers/Content'
import Cronograma from '../containers/Cronograma'
import Apresentacao from '../containers/Apresentacao'
import ContentFinish from '../components/courseContent/ContentFinish'
import NoContent from '../components/courseContent/NoContent'

const ContentsRoutes = props => {
  return (
    <Switch>
      <PrivateRoute exact path="/curso/:id/cronograma" component={() => {
        return <Cronograma {...props} />
      }
      } />
      <PrivateRoute exact path="/curso/:id/apresentacao" component={() => {
        return <Apresentacao {...props} />
      }
      } />
      <PrivateRoute exact path="/curso/:id/concluido" component={() => {
        return <ContentFinish {...props} />
      }
      } />
      <PrivateRoute exact path="/curso/:id/semconteudo" component={() => {
        return <NoContent {...props} />
      }
      } />
      <PrivateRoute exact path="/curso/:id/:conteudoId?" component={() => {
        return <Content {...props} />
      }
      } />
    </Switch>
  )
}
export default withRouter(ContentsRoutes)